import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import { TabType } from '../types';
import { formatDateTimeMsk } from '../../../utils/date';

interface MonitoringHeaderProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  cachedAt: string | null;
  isRefreshing: boolean;
  onRefresh: () => void;
}

const TABS: { key: TabType; label: string; Icon: React.ElementType }[] = [
  { key: 'list',   label: 'Список',      Icon: FormatListBulletedOutlinedIcon },
  { key: 'kanban', label: 'Kanban-Доска', Icon: ViewWeekOutlinedIcon },
];

const MonitoringHeader: React.FC<MonitoringHeaderProps> = ({
  activeTab,
  onTabChange,
  cachedAt,
  isRefreshing,
  onRefresh,
}) => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">

    {/* ── Tabs ── */}
    <div className="flex items-center gap-1">
      {TABS.map(({ key, label, Icon }) => {
        const isActive = activeTab === key;
        return (
          <button
            key={key}
            onClick={() => onTabChange(key)}
            className="flex items-center gap-2 px-4 py-2 transition-colors"
            style={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '14px',
              lineHeight: '17px',
              color: isActive ? '#1E61AF' : '#4B5563',
              background: isActive ? '#EFF6FF' : 'transparent',
              borderRadius: '8px',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            <Icon fontSize="small" style={{ color: isActive ? '#1E61AF' : '#4B5563' }} />
            {label}
          </button>
        );
      })}
    </div>

    {/* ── Right side: last update + refresh button ── */}
    <div className="flex items-center gap-3">
      {cachedAt && (
        <span
          className="hidden sm:block"
          style={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: '14px',
            color: '#9CA3AF',
          }}
        >
          Последнее обновление — {formatDateTimeMsk(cachedAt)}
        </span>
      )}
      <button
        onClick={onRefresh}
        disabled={isRefreshing}
        className="flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-semibold text-white transition-colors"
        style={{
          background: isRefreshing ? '#93C5FD' : '#1E61AF',
          cursor: isRefreshing ? 'not-allowed' : 'pointer',
          border: 'none',
        }}
      >
        {isRefreshing ? (
          <CircularProgress size={14} thickness={5} style={{ color: '#fff' }} />
        ) : (
          <RefreshOutlinedIcon fontSize="small" />
        )}
        Обновить все снимки
      </button>
    </div>
  </div>
);

export default MonitoringHeader;